import { Card, CardContent, CardDescription, CardHeader, CardMeta, Image } from "semantic-ui-react";
import styles from './TrufflePage.module.css';

export default function CardTruffle2() {
    return (
        <Card fluid className={styles.cardShadow}>
            <CardContent>
                <CardHeader>Fresh Black Truffle - Tuber Melanosporum</CardHeader>
                <CardMeta>
                    <Image src="/assets/melanosporum.png" fluid centered />
                </CardMeta>
                <CardDescription>

                </CardDescription>
            </CardContent>
            <CardContent extra>
                <span className={styles.price}>2000 </span>
            </CardContent>
        </Card >
    )
}